module.exports = __webpack_public_path__ + "img/PNGBARRA_2024.ebdfe051.png";